<template>
    <div v-if="isOpen" class="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/40 p-4" @click.self="close">
        <div
            :id="id"
            role="dialog"
            class="relative my-8 w-full rounded bg-white shadow-lg"
            :class="sizeClass"
        >
            <div class="flex items-start justify-between gap-3 border-b border-gray-200 px-4 py-3">
                <h4 class="m-0 min-w-0 flex-1 break-words text-base font-display leading-snug text-nav-active sm:text-lg">{{ title }}</h4>
                <button type="button" class="shrink-0 text-xl leading-none text-gray-500 hover:text-gray-800" aria-label="Close" @click="close">
                    &times;
                </button>
            </div>
            <div class="modal-body px-4 py-4">
                <slot/>
            </div>
            <div v-if="$slots.footer" class="modal-footer flex flex-wrap items-center justify-end gap-2 border-t border-gray-200 px-4 py-4">
                <slot name="footer"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BModal',
    compatConfig: {
        COMPONENT_V_MODEL: false
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        modelValue: {
            type: Boolean,
            default: undefined
        },
        title: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'md'
        },
        id: {
            type: String,
            default: null
        }
    },
    emits: ['input', 'update:modelValue'],
    computed: {
        isOpen () {
            return this.modelValue !== undefined ? this.modelValue : this.value
        },
        sizeClass () {
            if (this.size === 'lg') return 'max-w-3xl'
            if (this.size === 'sm') return 'max-w-md'
            return 'max-w-xl'
        }
    },
    watch: {
        isOpen (open) {
            document.body.style.overflow = open ? 'hidden' : ''
        }
    },
    methods: {
        close () {
            this.$emit('input', false)
            this.$emit('update:modelValue', false)
        }
    },
    beforeUnmount () {
        document.body.style.overflow = ''
    }
}
</script>
